// extracted by mini-css-extract-plugin
module.exports = {"NewGame":"NewGame_NewGame__3S-jK","button_menu":"NewGame_button_menu__1Ktje"};